<template>
  <TksCalculating />
</template>

<script>
import TksCalculating from "@/components/Calculatings/TksCalculating";
export default {
  components: {
    TksCalculating,
  },
};
</script>

<style></style>
